export const envKeys = {
    dev: 'development',
    test: 'test',
    pro: 'production',
    pre: "pre",
};
// 主配链api host
export const ZPChainApi = {
    [envKeys.dev]: 'https://accapi.global-dsc.cn',
    [envKeys.test]: 'https://accapi.global-dsc.cn',
    [envKeys.pro]: 'https://accapi.global-dsc.cn',
    [envKeys.pre]: 'https://accapi.global-dsc.cn',
};
// 大工程师api host
export const EngineerApi = {
    [envKeys.dev]: 'https://profitapi.global-dsc.cn',
    [envKeys.test]: 'https://profitapi.global-dsc.cn',
    [envKeys.pro]: 'https://profitapi.global-dsc.cn',
    [envKeys.pre]: 'https://profitapi.global-dsc.cn',
};
// 今日制造api60 host
export const JrzzApi60 = {
    [envKeys.dev]: 'https://api60.global-dsc.cn',
    [envKeys.test]: 'https://api60.global-dsc.cn',
    [envKeys.pro]: 'https://api60.global-dsc.cn',
    [envKeys.pre]: 'https://api60.global-dsc.cn',
};
// 今日制造api4 host
export const JrzzApi40 = {
    [envKeys.dev]: 'https://api40.global-dsc.cn',
    [envKeys.test]: 'https://api40.global-dsc.cn',
    [envKeys.pro]: 'https://api40.global-dsc.cn',
    [envKeys.pre]: 'https://api40.global-dsc.cn',
};
// api80 host
export const JrzzApi80 = {
    [envKeys.dev]: 'https://api80.global-dsc.cn',
    [envKeys.test]: 'https://api80.global-dsc.cn',
    [envKeys.pro]: 'https://api80.global-dsc.cn',
    [envKeys.pre]: 'https://api80.global-dsc.cn',
};
// api81广告服务
export const Api81 = {
    [envKeys.dev]: '/api81',
    [envKeys.test]: 'https://api81.global-dsc.cn',
    [envKeys.pro]: 'https://api81.global-dsc.cn',
    [envKeys.pre]: 'https://api81.global-dsc.cn',
};
// std host
export const StdApi = {
    [envKeys.dev]: 'https://standardapi.global-dsc.cn',
    [envKeys.test]: 'https://standardapi.global-dsc.cn',
    [envKeys.pro]: 'https://standardapi.global-dsc.cn',
    [envKeys.pre]: 'https://standardapi.global-dsc.cn',
};
// 济南图片资源服务地址1
export const JnImgHost = {
    [envKeys.dev]: '',
    [envKeys.test]: '',
    [envKeys.pro]: '',
    [envKeys.pre]: '',
};
// 济南图片资源服务地址2
export const JnImageHost = {
    [envKeys.dev]: 'https://img2cdn.global-dsc.cn',
    [envKeys.test]: 'https://img2cdn.global-dsc.cn',
    [envKeys.pro]: 'https://img2cdn.global-dsc.cn',
    [envKeys.pre]: 'https://img2cdn.global-dsc.cn',
};
// 杭州今日制造oss资源地址
export const HzOssHost = {
    [envKeys.dev]: 'https://down.global-dsc.cn/hzmdstatic/made_today',
    [envKeys.test]: 'https://down.global-dsc.cn/hzmdstatic/made_today',
    [envKeys.pro]: 'https://down.global-dsc.cn/hzmdstatic/made_today',
    [envKeys.pre]: 'https://down.global-dsc.cn/hzmdstatic/made_today',
};
// 济南oss资源地址
export const JnOssHost = {
    [envKeys.dev]: 'https://big-engineer.obs.cn-north-4.myhuaweicloud.com',
    [envKeys.test]: 'https://big-engineer.obs.cn-north-4.myhuaweicloud.com',
    [envKeys.pro]: 'https://big-engineer.obs.cn-north-4.myhuaweicloud.com',
    [envKeys.pre]: 'https://big-engineer.obs.cn-north-4.myhuaweicloud.com',
};
// 济南oss资源查看地址
export const JnOssLook = {
    [envKeys.dev]: 'https://prodimg.global-dsc.cn',
    [envKeys.test]: 'https://prodimg.global-dsc.cn',
    [envKeys.pro]: 'https://prodimg.global-dsc.cn',
    [envKeys.pre]: 'https://prodimg.global-dsc.cn',
};
// =============================
// === 各个项目的web页面地址 ===
// =============================
/**大工程师web服务地址 */
export const EngineerWeb = {
    [envKeys.dev]: 'http://127.0.0.1:9000',
    [envKeys.test]: 'https://big-engineer.global-dsc.cn',
    [envKeys.pro]: 'https://big-engineer.global-dsc.cn',
    [envKeys.pre]: 'https://netest.global-dsc.cn',
};
// 聊天服务地址
export const ImWeb = {
    [envKeys.dev]: 'http://127.0.0.1:8010',
    [envKeys.test]: 'https://big-engineer2.global-dsc.cn',
    [envKeys.pro]: 'https://big-engineer2.global-dsc.cn',
    [envKeys.pre]: 'https://big-engineer2.global-dsc.cn',
};
// 主配链web服务地址
export const ZPChainWeb = {
    [envKeys.dev]: 'http://127.0.0.1:3999',
    [envKeys.test]: 'https://keyuanbao.global-dsc.cn/kybweb',
    [envKeys.pro]: 'https://keyuanbao.global-dsc.cn/kybweb',
    [envKeys.pre]: 'https://keyuanbao.global-dsc.cn/kybweb',
};
// 主配链worker服务地址
export const ZPChainWorkerWeb = {
    [envKeys.dev]: 'http://127.0.0.1:8080',
    [envKeys.test]: 'https://keyuanbao.global-dsc.cn',
    [envKeys.pro]: 'https://keyuanbao.global-dsc.cn',
    [envKeys.pre]: 'https://keyuanbao.global-dsc.cn',
};
// 客源宝体系项目公共页面地址
export const EngineerCommon = {
    [envKeys.dev]: 'http://127.0.0.1:5173',
    [envKeys.test]: 'https://www.global-dsc.cn/commonweb/',
    [envKeys.pro]: 'https://www.global-dsc.cn/commonweb/',
    [envKeys.pre]: 'https://www.global-dsc.cn/commonweb/',
};
// 企业选型服务地址
export const LectoWeb = {
    [envKeys.dev]: '',
    [envKeys.test]: '',
    [envKeys.pro]: '',
    [envKeys.pre]: '',
};
